import type { IWhoamiApi } from "../../application/interfaces/IWhoamiApi";
import type { WhoamiDto } from "../../shared/WhoamiDto";
import type { IAccessTokenProvider } from "../../application/interfaces/IAccessTokenProvider";
import type { IAppConfigProvider } from "../../application/interfaces/IAppConfigProvider";

export class WhoamiApi implements IWhoamiApi {
  readonly configProvider: IAppConfigProvider;
  readonly tokenProvider: IAccessTokenProvider;

  constructor(
    configProvider: IAppConfigProvider,
    tokenProvider: IAccessTokenProvider,
  ) {
    this.configProvider = configProvider;
    this.tokenProvider = tokenProvider;
  }

  // Diese Anfrage NIEMALS cachen!
  // Sie wird von userService.heartbeat benutzt.
  async whoami(): Promise<WhoamiDto | null> {
    const token = await this.tokenProvider.getAccessToken();
    const config = await this.configProvider.getAppConfig();
    const headers: Record<string, string> = {
      "X-Api-Key": config.apiKey,
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const url = `${config.apiUrl}/Whoami`;
    const response = await fetch(url, {
      headers,
    });
    return (await response.json()) as WhoamiDto;
  }
}
